import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import {
  ExchangeAccessTokenDocument,
  type ExchangeAccessTokenMutation,
  type ExchangeAccessTokenMutationVariables,
} from 'generated/id-service-env-administration';
import { apolloClient } from './apolloClient';

export const environmentApolloClient = (
  environmentId: string,
  targetEndpoint: string,
): ApolloClient<Record<string, unknown>> => {
  const authLink = setContext(async (_, { headers }) => {
    const token = await getAccessToken(environmentId);

    let authorizationHeader: string;
    if (token) {
      authorizationHeader = `Bearer ${token}`;
    } else {
      authorizationHeader = ''; // TODO: Handle scenario when token is not retrieved
    }

    return {
      headers: {
        ...headers,
        Authorization: authorizationHeader,
      },
    };
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(
      createHttpLink({
        uri: targetEndpoint,
      }),
    ),
  });

  return client;
};

const getAccessToken = async (
  environmentId: string,
): Promise<string | undefined> => {
  // Exchange admin-token to a user-token
  const client = apolloClient();
  const response = await client.mutate<
    ExchangeAccessTokenMutation,
    ExchangeAccessTokenMutationVariables
  >({
    mutation: ExchangeAccessTokenDocument,
    variables: {
      input: {
        environmentId,
      },
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.exchangeAccessToken.accessToken;
};
